import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BadgeCreateLayer from "../components/BadgeCreateLayer";

const BadgeCreateFormPage = () => {
    return (
        <MasterLayout>
            <BadgeCreateLayer />
        </MasterLayout>
    );
};

export default BadgeCreateFormPage;
